<template>
  <b-modal 
    id="historico-vinculo-unidade"
    centered
    size="lg"
    :visible="false"
    :no-close-on-backdrop="true"
    :hide-footer="true"
  >
    <div class="col-12 px-0">
      <div class="col-12">
          <h4><i class="fas fa-history">  </i>  Histórico de Vínculo(s)</h4>
      </div>
      <load v-if="loading" mode="table" />
      <div v-else class="col-md-12 mb-3">
        <div v-if="unidadesTecnico.length <= 0">Nenhum registro encontrado</div>
        <table
          class="table table-bordered bg-white table-sm"
          v-for="item in unidadesTecnico"
          :key="item.id"
        >
          <tr>
            <td class="bg-gray" colspan="2">
              O Vínculo deste <b>Técnico</b> com a Unidade
              <b>{{ item.unidade_id }}</b> foi atualizado para
              <b>{{ item.status == 2 ? 'Inativo' : 'Ativo' }}</b>
            </td>
          </tr>
          <tr>
            <td>Data da ação: {{ formatDate(item.updated_at) }}</td>
          </tr>
        </table>
      </div>
    </div>
  </b-modal>
</template>
<script>
import moment from 'moment';
export default {
  props: ["unidadesTecnico"],
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    }
  }
};
</script>
